// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout_pageLayout__RJHRI","content":"PageLayout_content__PJlNQ","paddedContent":"PageLayout_paddedContent__sUvfQ"};